// import { sensors } from '@/utils/log';
import eleManager from '@/manager/electron';

export const state = () => ({
  // 这里是全局数据保存的地方
  userInfo: {},
  colorMode: 'light',
  currentOrg: 0,
  sensors: null,
  showHeadGuide: 0,
  isShowSubScribe: false,
});
// 修改state里面的函数必须用到mutations里面的函数
export const mutations = {
  setShowHeadGuide(current_state, data) {
    current_state.showHeadGuide = data;
  },
  setUserInfo(current_state, data) {
    // 每个 mutation 函数都可以接受到两个参数
    // 第一个是 state 对象本身
    // 第二是调用函数时额外添加的数据
    // 这里需要做的就是改变 state 数据
    // 这样外面调用这个函数, 并且传入数据, 即可改变当前的 userInfo 属性
    const sensors = require('@/utils/log').sensors;
    if (sensors) {
      sensors.setPublic({
        // 需要设置的共有属性
        mguser_id: data.id,
        user_name: data.name,
      });
    }
    if (data) {
      eleManager.loginStatusNotify(data);
      current_state.userInfo = data;
    }
  },
  setOrg(current_state, data) {
    current_state.currentOrg = data ?? 0;
  },
  setColor(current_state, data) {
    const setting_obj = require('@/settings/setting').setting_obj;
    data = data || localStorage.themeColor || setting_obj.colorPattern;
    if (data === 'dark' || data === 'light') {
      localStorage.themeColor = data;
      const html_node = document.getElementsByTagName('html')[0];
      html_node.setAttribute('t', data);
      html_node.setAttribute('class', data);
      if (window.$nuxt) {
        window.$nuxt.$emit('colorMode', data);
      }
      if (data) {
        current_state.colorMode = data;
      }
    }
  },
  setSensors(current_state, data) {
    if (data) {
      current_state.sensors = data;
    }
  },
  setSubScribe(current_state, data) {
    current_state.isShowSubScribe = data;
  },
};

export const actions = {
  handleHeadGuide({ commit }, data) {
    commit('setShowHeadGuide', data);
  },
  setSubScribe({ commit }, data) {
    commit('setSubScribe', data);
  },
};
